import {useRef} from 'react';
import COMPONENT_MAP from '../Repository/Components.js';
import {refreshServerVariable} from '../../../core/integration/Api.js';
import {useSnackbar} from '../SnackbarContext.js';
import {useLoading} from '../LoadingContext';

const AppMenuItemRouteTabPopup=({popupCallBack,rowId,parent,userData,application})=>{
    const pageDetailRef=useRef();
    const {showSnackbar}=useSnackbar();
    const {showLoading,hideLoading}=useLoading();

    const callOnPageDetail=async(callName,args)=>{
        if(pageDetailRef.current&&pageDetailRef.current[callName]){
            return await pageDetailRef.current[callName](args);
        }
    };

    const pageCallback=async(action,args)=>{
        if(action==='preUpsertRecord'){
            callOnPageDetail('handleClickEvent',{action:'save_nopre'});
        }
        else if(action==='invokeMethod'&&args?.name==='refresh_modules_config'){
            showLoading();
            refreshServerVariable('refresh-modules-config').then((data)=>{
                if('error' in data){showSnackbar(data.error,'error');}
                else{showSnackbar(data.message,'success');}
                hideLoading();
            });
        }
        else{
            popupCallBack(action,args);
        }
    };

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                ref={pageDetailRef}
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'AppMenuItemRouteTab'}
                entityParams={['_lang='+application.globalData.lang]}
                file={'AppMenuItemRouteTabPopup.js'}
                titleLabel={application.getLocale("TitleAppMenuItemRouteTab")}
                titleFieldName={'name'}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                openOnUpdate={true}
            />
        ):null;
    };
    return renderPageDetail();
}
export default AppMenuItemRouteTabPopup;
